import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Statistic, Col, Row, Divider, DatePicker } from 'antd';
import OrderService from "services/order"
import ProductService from "services/product"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate, useSearchParams } from 'react-router';
import dayjs from 'dayjs';
import _ from "lodash"
const { RangePicker } = DatePicker;
const service = new OrderService();
const productService = new ProductService();
const { Search } = Input;
const OrderList = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");
    let [searchParams, setSearchParams] = useSearchParams();
    const [products, setProducts] = useState([])
    const getCurrentSearParams = () => {
        const params = JSON.parse(searchParams.get("q")) ?? {};
        if (!params.status) {
            params.status = "proccesing"
        }
        return params;
    }

    const toFilterObject = () => {

    }
    var searchPr = getCurrentSearParams();
    const [filter, setFilter] = useState(searchPr)


    useEffect(() => {


        if (!_.isEqual(searchPr, filter)) {
            setFilter(searchPr)
        }

        //setFilter(params);
    }, [])


    useEffect(() => {
        delaySearch(filter);
        var searchPr = getCurrentSearParams();

        if (!_.isEqual(searchPr, filter)) {
            setSearchParams({ q: JSON.stringify(filter) })
        }

    }, [filter])




    const loadData = async (data) => {

        var postData = { ...data };
        // if (data.create_on) {
        //     var create_on = {
        //         start: data.create_on[0].startOf("d").toDate(),
        //         end: data.create_on[1].startOf("d").toDate(),
        //     }
        //     postData.create_on = create_on;
        // }
        var lst = await service.list(postData);
        setData(lst);
        const lstP = await productService.list({},["id", "name"]);
        setProducts(lstP);
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

    const onSearch = () => {
        delaySearch({});
    }

    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }

    const onDateRangeFilterChange = (e) => {
        // e => setFilterValue("create_on", e)
        if (!e) {

            setFilterValue("create_on", null)
        } else {
            setFilterValue("create_on", {
                start: e[0].startOf("d").format(),
                end: e[1].startOf("d").format()
            })
        }

        console.log("e", e)
    }


    const columns = [
        {
            title: 'Mã đơn hàng',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <Button type='text' onClick={e => navigate(`/order/${record.id}`)}>
                            {record.id}
                        </Button>
                        <div>
                            {formatDate(record.create_on)}
                        </div>
                    </Space>
                )

            }
        },

        {
            title: 'Khách hàng',

            render: (record) => {
                return (
                    <Space direction='vertical'>
                        <div>
                            ******{record.customer?.phone?.substring(6)}
                        </div>
                        <div>
                            {record.customer?.full_name}
                        </div>
                    </Space>
                )


            }
        },
        {
            title: 'Sản phẩm',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        <div>
                            {record.total_item}
                        </div>
                        <div>
                            {formatCurrency(record.total_amount)}
                        </div>
                    </Space>
                )


                return record.total_item
            }
        },
        {
            title: 'Trạng thái',

            render: (record) => {

                return (
                    <Space direction='vertical'>
                        {record.status == "canceled" &&
                            <div>
                                Đã Huỷ
                            </div>
                        }

                        {record.status == "finalized" &&
                            <div>
                                Đã Hoàn tất
                            </div>
                        }

                        {!["canceled", "finalized"].includes(record.status) &&
                            <>
                                <div>
                                    {record.payment_status.title}
                                </div>
                                <div>
                                    {record.shipping_status.title}
                                </div>
                            </>
                        }


                    </Space>
                )


                return record.total_item
            }
        },


    ];

    return (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card style={{ width: "100%" }}>
                <Space direction='vertical' style={{ width: "100%" }}>


                    <Search
                        placeholder="Mã đơn hàng hoặc thông tin khách hàng"
                        onSearch={onSearch}
                        value={filter.info}
                        onChange={e => setFilterValue("info", e.target.value)}
                        style={{
                            width: "100%",
                        }}
                    />
                    <Flex gap={16}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label>Trạng thái</label>
                            <Select value={filter.status} style={{ width: 200 }} onChange={e => setFilterValue("status", e)}>
                                <Select.Option value="proccesing">Đang xử lý</Select.Option>
                                <Select.Option value="canceled">Đã huỷ</Select.Option>
                                <Select.Option value="finalized">Đã hoàn tất</Select.Option>
                                <Select.Option value="all">Tất cả</Select.Option>
                            </Select>

                        </div>


                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label>Ngày tạo</label>
                            <RangePicker format={'DD/MM/YY'}

                                presets={[
                                    { label: 'Hôm nay', value: [dayjs().add(0, 'd'), dayjs().add(0, 'd')] },
                                    { label: 'Hôm qua', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
                                    { label: '7 ngày qua', value: [dayjs().add(-7, 'd'), dayjs().add(0, 'd')] },
                                    { label: '30 ngày qua', value: [dayjs().add(30, 'd'), dayjs().add(0, 'd')] },

                                ]}

                                value={filter.create_on ? [dayjs(filter.create_on.start), dayjs(filter.create_on.end)] : null}
                                onChange={onDateRangeFilterChange} />

                        </div>


                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label>Sản phẩm</label>
                            <Select mode='multiple' optionFilterProp="search_text" showSearch={true} value={filter.products} style={{ width: 300 }} onChange={e => setFilterValue("products", e)} options={products.map(x => ({ value: x.id, label: x.name, search_text: x.search_text }))}>

                            </Select>


                        </div>



                        {/* <div style={{ display: "flex", flexDirection: "column" }}>
                            <label>Khách hàng</label>
                            <Select defaultValue={"proccesing"} style={{ width: 200 }} onChange={e => setFilterValue("customer_id", e)}>
                                <Select.Option value="proccesing">Đang xử lý</Select.Option>
                                <Select.Option value="canceled">Đã huỷ</Select.Option>
                                <Select.Option value="finalized">Đã hoàn tất</Select.Option>
                            </Select>
                        </div> */}
                    </Flex>
                    <Divider></Divider>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Statistic title="Tổng số đơn" value={data.length} />
                        </Col>
                        <Col span={12}>
                            <Statistic title="Tổng số tiền" value={_.sumBy(data, x => x.total_amount)} precision={0} />

                        </Col>

                    </Row>

                    <Flex justify='flex-end'>
                        <Button type='primary' onClick={e => navigate("/order/add")}>Thêm mới</Button>
                    </Flex>
                </Space>
            </Card>
            <Card style={{ width: "100%" }}>
                <Table dataSource={data} columns={columns} />
            </Card>
        </Space>
    )
}

export default OrderList;
